{
    "Accessibility Menu": "Menu dostępności",
    "Reset settings": "Reset ustawień",
    "Close": "Zamknij",
    "Content Adjustments": "Dostosowanie zawartości",
    "Adjust Font Size": "Dostosuj rozmiar czcionki",
    "Highlight Title": "Podświetl tytuły",
    "Highlight Links": "Podświetl linki",
    "Readable Font": "Czytelna czcionka",
    "Color Adjustments": "Dostosowanie kolorów",
    "Dark Contrast": "Ciemny kontrast",
    "Light Contrast": "Jasny kontrast",
    "High Contrast": "Wysoki kontrast",
    "High Saturation": "Wysoka saturacja",
    "Low Saturation": "Niska saturacja",
    "Monochrome": "Monochromatyczność",
    "Tools": "Narzędzia",
    "Reading Guide": "Pomocnik czytania",
    "Stop Animations": "Wstrzymaj animacje",
    "Big Cursor": "Duży kursor",
    "Increase Font Size": "Zwiększ rozmiar czcionki",
    "Decrease Font Size": "Zmniejsz rozmiar czcionki",
    "Letter Spacing": "Odstępy między literami",
    "Line Height": "Wysokość wierszy",
    "Font Weight": "Pogrubiona czcionka",
    "Dyslexia Font": "Czcionka dla dyslektyków",
    "Language": "Język",
    "Open Accessibility Menu": "Otwórz menu dostępności"
}